module.exports = __webpack_public_path__ + "img/aa_pic_logo.e5508352.png";